/**
 * Hay hoja de compartir del sistema: en la app nativa siempre; en web, solo si
 * el navegador implementa Web Share (`navigator.share`). Sin ella, `Share.share`
 * de @capacitor/share tira error, así que quien la llame tiene que degradar
 * (por ejemplo, a copiar al portapapeles).
 */
export function canUseNativeShare(
  isNative: boolean,
  nav: Partial<Pick<Navigator, 'share'>> = navigator,
): boolean {
  return isNative || typeof nav.share === 'function';
}
